import { render } from "./NbSigninView.vue?vue&type=template&id=2c7a2878&scoped=true"
import script from "./NbSigninView.vue?vue&type=script&lang=js"
export * from "./NbSigninView.vue?vue&type=script&lang=js"

import "./NbSigninView.vue?vue&type=style&index=0&id=2c7a2878&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7a2878"]])

export default __exports__